const AboutMain = () => {
  return (
    <div className="about-main-container">
      <div className="about-heading-container">
        <h1>About Us</h1>
      </div>
      <div className="about-leaf-img">
        <img className="leaf-img" src="/images/basilLeaf.png" alt="" />
      </div>
      <div className="about-content-rows">
        <div className="about-row-1">
          <h1>We Are Your Favourite Store.</h1>
          <p>
            Tuas quisquam quo gravida proident harum, aptent ligula anim
            consequuntur, ultrices mauris, nunc voluptates lobortis, varius,
            potenti placeat! Fuga omnis. Cubilia congue. Recusandae. Vero
            penatibus quasi! Nostra tenetur dignissimos ultrices natus
            distinctio ultrices consequuntur numqu.
          </p>
          <p>
            Officiis fuga harum porro et? Similique rhoncus atque! Netus
            blanditiis provident nunc posuere. Rem sequi, commodo, lorem tellus
            elit, hic sem tenetur anim amet quas, malesuada proident platea
            corrupti expedita.
          </p>
        </div>
        <div className="about-row-2">
          <img src="/images/about-img.jpg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default AboutMain;
